<template>
  <div id="app" :style="{
    '--theme': verConfig.theme,
    '--navTheme': verConfig.navTheme,
    '--bg': '#fff',
    '--grey': '#b8ecff',
    '--gold': '#323233',
    '--black': '#000',
    '--navBg': '#c9b178',
    '--moduleColor': '#262626',
    '--hallBg': '#000',
    '--yellow': '#c9b178',
    '--light': '#fff',
    '--main_bg': '#f5f7fb',
    '--btn_bg': '#1989fa'
  }">
    <router-view />
    <WelfareDialog v-model="welfareDialogShow" :title="welfareDialogTitle" :content="welfareDialogContent" :msgId="messageInfo.id" @read="read"
      :next="nextmsg" :clickOverlay="false" backgroundImage="'./assets/home/dialog_bg.png'" />
    <div class="win_content">
      <van-dialog v-model="dialogContent" close-on-click-overlay :confirm-button-text="$t('btn.confirm')"
        confirm-button-color="#ee0a24" @confirm="winDialogConfirm" @close="winDialogConfirm">
        <template #title>
          <div class="win_title">{{ winContent.title || $t('通知') }}</div>
        </template>
        <div class="win_contents" v-html="winContent.content"></div>
      </van-dialog>
    </div>
    <div class="service" @click="serviceChange(0)">
      <img src="@/assets/new/goods/kefu.png" alt="">
    </div>
  </div>
</template>
<script>
import { Tabbar, TabbarItem, Toast, Dialog } from "vant";
import WelfareDialog from "@/components/welfareDialog.vue";
import { GET_UNREAD_MESSAGES } from "@tt/api";
import { CONTENT_WINNOTICE } from "@/api"
import {
  generateRandomString,
  baseEncode,
  setCookieValue,
  getCookieValue,
} from "@/utils/common";
export default {
  data() {
    return {
      welfareDialogShow: false,
      welfareDialogContent: "",
      welfareDialogTitle:"",
      messageInfo: {},
      msgList: [],
      nextmsg: false,
      dialogContent: false,
      winContent: {},
    };
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    WelfareDialog,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
  },
  created() {
    // this.$store.dispatch("getCountry");
    this.$store.dispatch("getList");

    if (!getCookieValue("channel")) {
      setCookieValue("channel", baseEncode());
    }
    // if (!localStorage.getItem('user-info')) {
    //   if (this.$router.history.current.name !== 'login') {
    //     // this.$router.replace('login')
    //     this.$router.push('/login')
    //   }
    // }
    // this.$store.dispatch("getSystemConfig");
    sessionStorage.setItem("version-dialog-show", true);
    if (!localStorage.getItem("version")) {
      localStorage.setItem("version", "1.0.7");
    }
  },
  computed: {
    ifShowTabbar() {
      let list = ["goods", "financing", "cart", "record", "user"];
      // console.log(list.includes(this.$router.history.current.name));
      return list.includes(this.$router.history.current.name);
    },
    winNum() {
      return this.$store.getters.winNum
    }
  },
  methods: {
    serviceChange(num) {
      // window.ssq.push('chatOpen');
      this.$store.dispatch('toService');
      // this.getHome(num)
    },
    winDialogConfirm() {
      this.$store.dispatch('getWinNum', false);
    },
    onChange() {
      // window.console.log(123);
    },
    goto(path = ``) {
      this.$router.push(`/${path}`);
    },
    read(next = false, nextParams = {}) {
      if (nextParams && Object.keys(nextParams).length)
        this.messageInfo = nextParams;
      // this.msgList.shift();
      if (!!this.msgList[0].nextmsg && !next) {
        this.welfareDialogContent = this.msgList[0].nextmsg;
        if (!next) {
          this.nextmsg = true;
        } else {
          this.nextmsg = false;
        }
        this.welfareDialogShow = true;
      }
      // if (this.msgList.length) {
      //   this.welfareDialogContent = this.msgList[0].content;
      //   this.messageInfo = this.msgList[0];
      //   this.welfareDialogShow = true;
      // }
    },
    async getMessage() {
      // Toast.loading({ duration: 0 });
      try {
        const res = await GET_UNREAD_MESSAGES({
          perPage: 999,
          notify: 1,
          notify: 1,
        });
        Toast.clear();
        const { ret, msg, data } = res;
        
        if (!data.total) return;
        if (!!data.lists.length) {
          this.welfareDialogShow = true;
          if (!!this.messageInfo.id && this.messageInfo.id == data.lists[0].id)
          return;
          this.welfareDialogContent = data.lists[0].content;
          this.welfareDialogTitle = data.lists[0].title;
          this.messageInfo = data.lists[0];
          this.msgList = data.lists;
        }
      } catch (error) {
        // console.log(error);
        Toast.clear();
      }
    },
    async getWinnotice() {
      try {
        const { data } = await CONTENT_WINNOTICE();
        this.winContent = data.length && data[0]
        if (data.length && data[0]) {
          this.dialogContent = true;
        }
      } catch (error) { }
    }
  },
  watch: {
    $route(to, from) {
      const token = localStorage.getItem("token");
      if ((to.path === "/registrasi") | (to.path === "/login") | !token) {
        this.$store.dispatch('getWinNum', true);
        return;
      }
      this.getMessage();
      if (this.winNum) {
        this.getWinnotice();
      }
    },
  },
};

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>
<style>
@import url("./assets/iconfonts/iconfont.css");

.app_card {
  background: #ffffffe6;
  color: var(--theme);
  border-radius: 24px;
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(15, 23, 42, .08);
  border: 1px solid rgba(15, 23, 42, .08);
}

#app {
  width: 100%;
  height: 100%;
}

body {
  font-size: 16px;
  /* background-color: #fff; */
  background: #f5f7fb;
  -webkit-font-smoothing: antialiased;
  max-width: 648px;
  margin: 0 auto;
}

.van-nav-bar__placeholder,
.van-nav-bar {
  max-width: 648px;
  margin: 0 auto;
}

.van-nav-bar--fixed {
  left: auto !important;
}

a {
  position: fixed;
  top: -1000px;
}

.van-toast--loading {
  max-width: unset;
  min-height: unset;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  /* display:none */

}

.van-loading__spinner {
  margin: 0;
  width: 25px;
  height: 25px;

}
</style>
<style scoped lang="less">
.win_content {
  /deep/ .van-dialog {
    width: 75%;
    background-color: transparent;

    .van-dialog__header {
      background: #fff;
      color: #0f172a;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      padding: 0;

      .win_title {
        height: calc(40rem / 16);
        font-size: calc(15rem / 16);
        text-align: center;
        line-height: calc(40rem / 16);
      }
    }


    .win_contents {
      background-color: var(--light);
      padding-bottom: 0;
      box-sizing: border-box;
      padding: calc(10rem / 16);
      max-height: 70vh;
      overflow-y: scroll;

      p {
        white-space: normal;
        word-wrap: break-word;
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .van-button {
      border-radius: 0;
    }

    .van-dialog__cancel,
    .van-dialog__confirm {
      height: 50px;
    }

    .van-button--default {
      border: none !important
    }

    // .van-hairline--top::after {
    //   border: none !important;
    // }
  }
}
.service {
  position: fixed;
  right: calc(10rem / 16);
  bottom: calc(70rem / 16);
  z-index: 10;

  img {
    width: calc(44rem / 16);
    height: calc(44rem / 16);
    display: block;
    animation: moveUpDown .8s infinite alternate;
  }

  @keyframes moveUpDown {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.2);
    }
  }
}
</style>